export default __webpack_public_path__ + "static/media/bonfire.7a41f82d.png";